import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { StyledText } from "../../../assets/typography/typography";
import { PrimaryButton } from "../../../components/Buttons";
import { colors } from "../../../components/colors";
import { InLineLabel } from "../../../components/Label";

type UserBenefitProps = {
  name: string;
  remove: (() => void) | ((e: any) => void);
  sync?: () => void;
  children: React.ReactNode;
  type: "membercard" | "voucher";
  active: boolean;
  isRedeemed?: boolean;
};

export const UserBenefit = ({
  name,
  children,
  type,
  remove,
  sync,
  active,
  isRedeemed,
}: UserBenefitProps) => {
  return (
    <div
      className="d-flex flex-row justify-content-between"
      style={{ overflow: "scroll" }}
    >
      <div
        className="d-flex flex-row align-items-center"
        style={{ gap: "16px" }}
      >
        <div
          className="d-flex align-items-center justify-content-center p-3"
          style={{
            backgroundColor: colors.ctaLight,
            borderRadius: "4px",
          }}
        >
          <StyledText color={colors.ctaMain} className="bodyTextSemibold mb-0">
            {type === "membercard" && (
              <FontAwesomeIcon icon={solid("badge-percent")} />
            )}
            {type === "voucher" && <FontAwesomeIcon icon={solid("ticket")} />}
          </StyledText>
        </div>
        <div className="d-flex flex-column" style={{ gap: "8px" }}>
          <div
            className="d-flex flex-row align-items-center"
            style={{ gap: "8px" }}
          >
            <StyledText
              color={colors.textPrimary}
              className="bodyTextSemibold mb-0"
            >
              {name}
            </StyledText>
            {type === "voucher" && isRedeemed && (
              <InLineLabel
                backgroundColor={colors.successLight}
                color={colors.successDark}
              >
                Redeemed
              </InLineLabel>
            )}
          </div>
          {children}
        </div>
      </div>
      <div className="d-flex flex-row align-items-center">
        {active && (
          <>
            {sync && (
              <PrimaryButton
                type="button"
                hoverColor={colors.ctaLight}
                color={colors.textPrimary}
                backgroundColor="white"
                onClick={sync}
                className="w-fit"
              >
                Sync
              </PrimaryButton>
            )}
            <PrimaryButton
              type="button"
              hoverColor={colors.errorLight}
              color={colors.errorDark}
              backgroundColor="white"
              onClick={remove}
              className="w-fit"
            >
              Remove
            </PrimaryButton>
          </>
        )}
      </div>
    </div>
  );
};
